import React from 'react';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
// import Shop from './Pages/Shop';
import Contact from './Pages/Contact';
import Client from './Pages/client';
import Portfolio from './Pages/Portfolio';
// import Detail from './Pages/Detail';
import Card from './Pages/Card';
import Checkout from './Pages/Checkout';
import Categories from './Pages/Categories';
// import Thankyou from './Pages/Thankyou';
import Header from './Components/Header';
import Footer from './Components/Footer';

// import demo from './Pages/demo';
// import CategoriesShop from './Pages/CategoriesShop';
import SearchData from './Pages/SearchData';

// import Signup from './Pages/Admin/Signup';
// import EditCard from "./Pages/EditCart"
// import CategoriesBook from './Pages/CategoriesBook';
// import CategoriesBags from './Pages/CategoriesBags';
// import CategoriesShoes from './Pages/CategoriesShoes';
// import ShoesProduct from './Pages/ShoesProduct';
// import ShoesProductDetails from './Pages/ShoesProductDetails';
// import SchoolClassProduct from './Pages/SchoolClassProduct';
// import BagsClassProduct from './Pages/BagsClassProduct';
// import chat from './Pages/chat';
// import SignupOtp from './Pages/SignupOtp';


// import whatapps from './assets/images/what.png';






// import SubCategories from './Pages/Categories';
// import SubCategoriesProduct from './Pages/SubCategoriesProduct';












import VillaMaintenanceContractDubaiVillaAMCDubai from './Pages/Villa Maintenance Contract Dubai Villa AMC Dubai';
import BestAnnualMaintenanceContractPackages from './Pages/Best Annual Maintenance Contract Packages';
import AnnualMaintenanceContractinDubai from './Pages/Annual Maintenance Contract in Dubai';
import AMCindubai from './Pages/AMCindubai';
import AMCPackagesDubaiAnnualMaintenanceContract from './Pages/AMC Packages Dubai Annual Maintenance Contract';


import AMC1 from './Pages/AMC1';
import AMC2 from './Pages/AMC2';
import AMC3 from './Pages/AMC3';
import AMC4 from './Pages/AMC4';
import AMC5 from './Pages/AMC5';
import AMC6 from './Pages/AMC6';
import AMC7 from './Pages/AMC7';
import AMC8 from './Pages/AMC8';


import GardenMaintenanceServicesDubai from './Pages/Garden Maintenance Services Dubai';
import TopRatedLandscapingAndPlantMaintenanceServicesDubai from './Pages/Top-Rated Landscaping and Plant Maintenance Services Dubai';
import PremiumGardenMaintenanceServicesDubai from './Pages/Premium Garden Maintenance Services Dubai';
import BestLandscapingAndGardeningServicesCompanyInDubai from './Pages/Best Landscaping & Gardening Services Company in Dubai';
import GardenLandscapingDubaiExpertGardenCare from './Pages/Garden Landscaping Dubai - Expert Garden Care';
import BookProfessionalGardenMaintenanceServicesInDubai from './Pages/Book Professional Garden Maintenance Services In Dubai';
import GardenLandscapingDubaiTrustedGardenersInDubai from './Pages/Garden Landscaping Dubai Trusted Gardeners in Dubai';
import DubaiBestLandscapingAndGardenMaintenance from './Pages/Dubai Best Landscaping And Garden Maintenance';
import YourTopLandscapingCompanyInDubai from './Pages/Your Top Landscaping Company in Dubai';
import TopIndoorPlantsMaintenanceServiceDubai from './Pages/Top Indoor Plants Maintenance Service Dubai';
import LandscapeAndGardeningWorksAndMaintenanceInDubai from './Pages/Landscape & Gardening works & Maintenance in Dubai';
import AffordableGardeningServicesInDubai from './Pages/Affordable Gardening Services in Dubai';
import LandscapingAndGardeningServicesCompanyDubai from './Pages/Landscaping and Gardening services company – Dubai';
import UrbanLandscapesLuxuryLandscapingDesignDubai from './Pages/Urban Landscapes Luxury Landscaping Design Dubai';
import BestDubaiLandscapeDubaiTopLandscapingFirm from "./Pages/Best Dubai Landscape Dubai's top landscaping firm";
import OneOfTheBestLandscapingCompaniesInDubai from './Pages/One of the best landscaping companies in Dubai';
import PremiumLandscapingCompanyInDubai from './Pages/Premium Landscaping Company in Dubai';
import BestChoiceLandscapeGardeningLLCDubai from './Pages/Best Choice Landscape Gardening LLC Dubai';
import LandscapingInDubaiGreenLawnLandscapingAndGardening from './Pages/Landscaping in Dubai Greenlawn Landscaping & gardening';
import BestLandscapingAndLawnServiceInDubai from './Pages/Best Landscaping And Lawn Service In Dubai';
import ExpertGardenLandscapingInDubaiOutdoorOasis from './Pages/Expert Garden Landscaping in Dubai for Your Outdoor Oasis';
import BestGardeningCompaniesLandscapingWorkInDubai from './Pages/Best Gardening Companies Landscaping Work in Dubai';
import DubaiLandscapeHomeOfficeLandscapeIndoorOutdoor from './Pages/Dubai Landscaping Home office Landscape Indoor Outdoor1';
import BestLandscapingCompaniesInDubaiVillaGarden from './Pages/Best Landscaping Companies in Dubai-Villa Garden';
import LandscapingServicesInUaeLandscapingCompanyInDubai from './Pages/Landscaping Services in UAE Landscaping Company in Dubai';
import SwimmingPoolAndLandscapingCompanyInDubaiUae from './Pages/Swimming Pool and Landscaping Company in Dubai, UAE';



// Indoor Plant Maintenance Service (AMC) in Dubai
// Annual Maintenance Contract Dubai | AMC Services in UAE
// Garden Maintenance AMC Services at Discounted Prices
// Dubai Landscape Maintenance - Beautiful Gardens Made Easy
// Garden Maintenance AMC Services at Best Offers
// Looking For AMC for Your Lawn? | Garden Maintenance Services
// Garden Maintenance Services | Landscaping Services in Dubai 
// Annual Indoor Plant Maintenance #1 Plant care service Dubai





// Landscaping Companies in Dubai - Landscaping in Dubai
// Landscaping Company Dubai | Landscaping designer
// Best Landscaping Company in Dubai
// Landscaping Dubai | Landscaping Company Dubai 
// Desert Group | Best and Quality Landscaping Company in Dubai
// Premium Landscaping Company in Dubai 
// Best in Dubai Landscapes | Best UAE Landscaping
// Landscaping Services Dubai
// Landscaping Services | Garden Landscaping Company in Dubai
// Your Top Landscaping Company in Dubai | Planters
// Best landscape architecture in Dubai - Ducon Outdoor Living
// Landscaping and Gardening services company – Dubai
// Landscaping Services | Dubai | Abu Dhabi | UAE
// One of the best landscaping companies in Dubai
// Best Landscaping Company in Dubai | UAE
// Gardening Services in Dubai | Top Landscaping & Gardening


import Land1 from './Pages/Land1';
import Land2 from './Pages/Land2';
import Land3 from './Pages/Land3';
import Land4 from './Pages/Land4';
import Land5 from './Pages/Land5';
import Land6 from './Pages/Land6';
import Land7 from './Pages/Land7';
import Land8 from './Pages/Land8';
import Land9 from './Pages/Land9';
import Land10 from './Pages/Land10';
import Land11 from './Pages/Land11';
import Land12 from './Pages/Land12';
import Land13 from './Pages/Land13';
import Land14 from './Pages/Land14';
import Land15 from './Pages/Land15';
import Land16 from './Pages/Land16';








import Page1 from './Pages/Page (1)';
import Page2 from './Pages/Page (2)';
import Page3 from './Pages/Page (3)';
import Page4 from './Pages/Page (4)';
import Page5 from './Pages/Page (5)';
import Page6 from './Pages/Page (6)';
import Page7 from './Pages/Page (7)';
import Page8 from './Pages/Page (8)';
import Page9 from './Pages/Page (9)';
import Page10 from './Pages/Page (10)';
import Page11 from './Pages/Page (11)';
import Page12 from './Pages/Page (12)';
import Page13 from './Pages/Page (13)';
import Page14 from './Pages/Page (14)';
import Page15 from './Pages/Page (15)';
import Page16 from './Pages/Page (16)';
import Page17 from './Pages/Page (17)';
import Page18 from './Pages/Page (18)';
import Page19 from './Pages/Page (19)';
import Page20 from './Pages/Page (20)';
import Page21 from './Pages/Page (21)';
import Page22 from './Pages/Page (22)';
import Page23 from './Pages/Page (23)';
import Page24 from './Pages/Page (24)';
import Page25 from './Pages/Page (25)';
import Page26 from './Pages/Page (26)';
import Page27 from './Pages/Page (27)';
import Page28 from './Pages/Page (28)';
import Page29 from './Pages/Page (29)';
import Page30 from './Pages/Page (30)';

import Page31 from './Pages/Page (31)';
import Page32 from './Pages/Page (32)';
import Page33 from './Pages/Page (33)';
import Page34 from './Pages/Page (34)';
import Page35 from './Pages/Page (35)';
import Page36 from './Pages/Page (36)';
import Page37 from './Pages/Page (37)';
import Page38 from './Pages/Page (38)';
import Page39 from './Pages/Page (39)';
import Page40 from './Pages/Page (40)';
import Page41 from './Pages/Page (41)';
import Page42 from './Pages/Page (42)';
import Page43 from './Pages/Page (43)';
import Page44 from './Pages/Page (44)';
import Page45 from './Pages/Page (45)';
import Page46 from './Pages/Page (46)';
import Page47 from './Pages/Page (47)';
import Page48 from './Pages/Page (48)';
import Page49 from './Pages/Page (49)';
import Page50 from './Pages/Page (50)';
import Page51 from './Pages/Page (51)';
import Page52 from './Pages/Page (52)';
import Page53 from './Pages/Page (53)';
import Page54 from './Pages/Page (54)';
import Page55 from './Pages/Page (55)';
import Page56 from './Pages/Page (56)';
import Page57 from './Pages/Page (57)';
import Page58 from './Pages/Page (58)';
import Page59 from './Pages/Page (59)';
import Page60 from './Pages/Page (60)';
import Page61 from './Pages/Page (61)';
import Page62 from './Pages/Page (62)';
import Page63 from './Pages/Page (63)';

import Page64 from './Pages/Page (64)';
import Page65 from './Pages/Page (65)';
import Page66 from './Pages/Page (66)';
import Page67 from './Pages/Page (67)';
import Page68 from './Pages/Page (68)';
import Page69 from './Pages/Page (69)';
import Page70 from './Pages/Page (70)';
import Page71 from './Pages/Page (71)';
import Page72 from './Pages/Page (72)';
import Page73 from './Pages/Page (73)';
import Page74 from './Pages/Page (74)';
import Page75 from './Pages/Page (75)';
import Page76 from './Pages/Page (76)';
import Page77 from './Pages/Page (77)';
import Page78 from './Pages/Page (78)';
import Page79 from './Pages/Page (79)';
import Page80 from './Pages/Page (80)';
import Page81 from './Pages/Page (81)';
import Page82 from './Pages/Page (82)';
import Page83 from './Pages/Page (83)';
import Page84 from './Pages/Page (84)';
import Page85 from './Pages/Page (85)';
import Page86 from './Pages/Page (86)';
import Page87 from './Pages/Page (87)';
import Page88 from './Pages/Page (88)';
import Page89 from './Pages/Page (89)';
import Page90 from './Pages/Page (90)';
import Page91 from './Pages/Page (91)';
import Page92 from './Pages/Page (92)';
import Page93 from './Pages/Page (93)';
import Page94 from './Pages/Page (94)';
import Page95 from './Pages/Page (95)';
import Page96 from './Pages/Page (96)';
import Page97 from './Pages/Page (97)';
import Page98 from './Pages/Page (98)';
import Page99 from './Pages/Page (99)';
import Page100 from './Pages/Page (100)';
import Page101 from './Pages/Page (101)';
import Page102 from './Pages/Page (102)';
import Page103 from './Pages/Page (103)';
import Page104 from './Pages/Page (104)';
import Page105 from './Pages/Page (105)';
import Page106 from './Pages/Page (106)';
import Page107 from './Pages/Page (107)';
import Page108 from './Pages/Page (108)';
import Page109 from './Pages/Page (109)';
import Page110 from './Pages/Page (110)';
import Page111 from './Pages/Page (111)';
import Page112 from './Pages/Page (112)';
import Page113 from './Pages/Page (113)';
import Page114 from './Pages/Page (114)';
import Page115 from './Pages/Page (115)';
import Page116 from './Pages/Page (116)';
import Page117 from './Pages/Page (117)';
import Page118 from './Pages/Page (118)';
import Page119 from './Pages/Page (119)';
import Page120 from './Pages/Page (120)';
import Page121 from './Pages/Page (121)';
import Page122 from './Pages/Page (122)';
import Page123 from './Pages/Page (123)';
import Page124 from './Pages/Page (124)';
import Page125 from './Pages/Page (125)';
import Page126 from './Pages/Page (126)';
import Page127 from './Pages/Page (127)';
import Page128 from './Pages/Page (128)';


import Page129 from './Pages/Page (129)';
import Page130 from './Pages/Page (130)';
import Page131 from './Pages/Page (131)';
import Page132 from './Pages/Page (132)';
import Page133 from './Pages/Page (133)';
import Page134 from './Pages/Page (134)';
import Page135 from './Pages/Page (135)';
import Page136 from './Pages/Page (136)';
import Page137 from './Pages/Page (137)';
import Page138 from './Pages/Page (138)';
import Page139 from './Pages/Page (139)';
import Page140 from './Pages/Page (140)';
import Page141 from './Pages/Page (141)';
import Page142 from './Pages/Page (142)';
import Page143 from './Pages/Page (143)';
import Page144 from './Pages/Page (144)';
import Page145 from './Pages/Page (145)';
import Page146 from './Pages/Page (146)';
import Page147 from './Pages/Page (147)';
import Page148 from './Pages/Page (148)';
import Page149 from './Pages/Page (149)';
import Page150 from './Pages/Page (150)';
import Page151 from './Pages/Page (151)';
import Page152 from './Pages/Page (152)';
import Page153 from './Pages/Page (153)';
import Page154 from './Pages/Page (154)';
import Page155 from './Pages/Page (155)';
import Page156 from './Pages/Page (156)';
import Page157 from './Pages/Page (157)';
import Page158 from './Pages/Page (158)';
import Page159 from './Pages/Page (159)';
import Page160 from './Pages/Page (160)';

import Page161 from './Pages/Page (161)';
import Page162 from './Pages/Page (162)';
import Page163 from './Pages/Page (163)';
import Page164 from './Pages/Page (164)';
import Page165 from './Pages/Page (165)';
import Page166 from './Pages/Page (166)';
import Page167 from './Pages/Page (167)';
import Page168 from './Pages/Page (168)';
import Page169 from './Pages/Page (169)';
import Page170 from './Pages/Page (170)';
import Page171 from './Pages/Page (171)';
import Page172 from './Pages/Page (172)';
import Page173 from './Pages/Page (173)';
import Page174 from './Pages/Page (174)';
import Page175 from './Pages/Page (175)';
import Page176 from './Pages/Page (176)';
import Page177 from './Pages/Page (177)';
import Page178 from './Pages/Page (178)';
import Page179 from './Pages/Page (179)';
import Page180 from './Pages/Page (180)';
import Page181 from './Pages/Page (181)';
import Page182 from './Pages/Page (182)';
import Page183 from './Pages/Page (183)';
import Page184 from './Pages/Page (184)';
import Page185 from './Pages/Page (185)';
import Page186 from './Pages/Page (186)';
import Page187 from './Pages/Page (187)';
import Page188 from './Pages/Page (188)';
import Page189 from './Pages/Page (189)';
import Page190 from './Pages/Page (190)';
import Page191 from './Pages/Page (191)';
import Page192 from './Pages/Page (192)';








import Page193 from './Pages/Page (193)';
import Page194 from './Pages/Page (194)';
import Page195 from './Pages/Page (195)';
import Page196 from './Pages/Page (196)';
import Page197 from './Pages/Page (197)';
import Page198 from './Pages/Page (198)';
import Page199 from './Pages/Page (199)';
import Page200 from './Pages/Page (200)';
import Page201 from './Pages/Page (201)';
import Page202 from './Pages/Page (202)';
import Page203 from './Pages/Page (203)';
import Page204 from './Pages/Page (204)';
import Page205 from './Pages/Page (205)';
import Page206 from './Pages/Page (206)';
import Page207 from './Pages/Page (207)';
import Page208 from './Pages/Page (208)';
import Page209 from './Pages/Page (209)';
import Page210 from './Pages/Page (210)';
import Page211 from './Pages/Page (211)';
import Page212 from './Pages/Page (212)';
import Page213 from './Pages/Page (213)';
import Page214 from './Pages/Page (214)';
import Page215 from './Pages/Page (215)';
import Page216 from './Pages/Page (216)';
import Page217 from './Pages/Page (217)';
import Page218 from './Pages/Page (218)';
import Page219 from './Pages/Page (219)';
import Page220 from './Pages/Page (220)';
import Page221 from './Pages/Page (221)';
import Page222 from './Pages/Page (222)';
import Page223 from './Pages/Page (223)';
import Page224 from './Pages/Page (224)';
import Page225 from './Pages/Page (225)';
import Page226 from './Pages/Page (226)';
import Page227 from './Pages/Page (227)';
import Page228 from './Pages/Page (228)';
import Page229 from './Pages/Page (229)';
import Page230 from './Pages/Page (230)';
import Page231 from './Pages/Page (231)';
import Page232 from './Pages/Page (232)';
import Page233 from './Pages/Page (233)';
import Page234 from './Pages/Page (234)';
import Page235 from './Pages/Page (235)';
import Page236 from './Pages/Page (236)';
import Page237 from './Pages/Page (237)';
import Page238 from './Pages/Page (238)';
import Page239 from './Pages/Page (239)';
import Page240 from './Pages/Page (240)';
import Page241 from './Pages/Page (241)';
import Page242 from './Pages/Page (242)';
import Page243 from './Pages/Page (243)';
import Page244 from './Pages/Page (244)';
import Page245 from './Pages/Page (245)';
import Page246 from './Pages/Page (246)';
import Page247 from './Pages/Page (247)';
import Page248 from './Pages/Page (248)';
import Page249 from './Pages/Page (249)';
import Page250 from './Pages/Page (250)';
import Page251 from './Pages/Page (251)';
import Page252 from './Pages/Page (252)';
import Page253 from './Pages/Page (253)';
import Page254 from './Pages/Page (254)';
import Page255 from './Pages/Page (255)';
import Page256 from './Pages/Page (256)';
import Page257 from './Pages/Page (257)';
import Page258 from './Pages/Page (258)';
import Page259 from './Pages/Page (259)';
import Page260 from './Pages/Page (260)';
import Page261 from './Pages/Page (261)';
import Page262 from './Pages/Page (262)';
import Page263 from './Pages/Page (263)';
import Page264 from './Pages/Page (264)';
import Page265 from './Pages/Page (265)';
import Page266 from './Pages/Page (266)';
import Page267 from './Pages/Page (267)';
import Page268 from './Pages/Page (268)';
import Page269 from './Pages/Page (269)';
import Page270 from './Pages/Page (270)';
import Page271 from './Pages/Page (271)';
import Page272 from './Pages/Page (272)';
import Page273 from './Pages/Page (273)';
import Page274 from './Pages/Page (274)';
import Page275 from './Pages/Page (275)';
import Page276 from './Pages/Page (276)';
import Page277 from './Pages/Page (277)';
import Page278 from './Pages/Page (278)';
import Page279 from './Pages/Page (279)';
import Page280 from './Pages/Page (280)';
import Page281 from './Pages/Page (281)';
import Page282 from './Pages/Page (282)';


import LandscapingPage1 from './Pages/LandscapingPage (1)';
import LandscapingPage2 from './Pages/LandscapingPage (2)';
import LandscapingPage3 from './Pages/LandscapingPage (3)';
import LandscapingPage4 from './Pages/LandscapingPage (4)';
import LandscapingPage5 from './Pages/LandscapingPage (5)';
import LandscapingPage6 from './Pages/LandscapingPage (6)';
import LandscapingPage7 from './Pages/LandscapingPage (7)';
import LandscapingPage8 from './Pages/LandscapingPage (8)';
import LandscapingPage9 from './Pages/LandscapingPage (9)';
import LandscapingPage10 from './Pages/LandscapingPage (10)';
import LandscapingPage11 from './Pages/LandscapingPage (11)';
import LandscapingPage12 from './Pages/LandscapingPage (12)';
import LandscapingPage13 from './Pages/LandscapingPage (13)';
import LandscapingPage14 from './Pages/LandscapingPage (14)';
import LandscapingPage15 from './Pages/LandscapingPage (15)';
import LandscapingPage16 from './Pages/LandscapingPage (16)';
import LandscapingPage17 from './Pages/LandscapingPage (17)';
import LandscapingPage18 from './Pages/LandscapingPage (18)';
import LandscapingPage19 from './Pages/LandscapingPage (19)';
import LandscapingPage20 from './Pages/LandscapingPage (20)';
import LandscapingPage21 from './Pages/LandscapingPage (21)';
import LandscapingPage22 from './Pages/LandscapingPage (22)';
import LandscapingPage23 from './Pages/LandscapingPage (23)';
import LandscapingPage24 from './Pages/LandscapingPage (24)';
import LandscapingPage25 from './Pages/LandscapingPage (25)';
import LandscapingPage26 from './Pages/LandscapingPage (26)';






import Landscape1 from './Pages/Landscape (1)';
import Landscape2 from './Pages/Landscape (2)';
import Landscape3 from './Pages/Landscape (3)';
import Landscape4 from './Pages/Landscape (4)';
import Landscape5 from './Pages/Landscape (5)';
import Landscape6 from './Pages/Landscape (6)';
import Landscape7 from './Pages/Landscape (7)';
import Landscape8 from './Pages/Landscape (8)';
import Landscape9 from './Pages/Landscape (9)';
import Landscape10 from './Pages/Landscape (10)';
import Landscape11 from './Pages/Landscape (11)';
import Landscape12 from './Pages/Landscape (12)';
import Landscape13 from './Pages/Landscape (13)';
import Landscape14 from './Pages/Landscape (14)';
import Landscape15 from './Pages/Landscape (15)';
import Landscape16 from './Pages/Landscape (16)';
import Landscape17 from './Pages/Landscape (17)';
import Landscape18 from './Pages/Landscape (18)';
import Landscape19 from './Pages/Landscape (19)';
import Landscape20 from './Pages/Landscape (20)';
import Landscape21 from './Pages/Landscape (21)';
import Landscape22 from './Pages/Landscape (22)';
import Landscape23 from './Pages/Landscape (23)';














import Privacy from './Pages/Privacy';
import consign from './Pages/consign';
// import Shipping from './Pages/Shipping';
import tracking from './Pages/tracking';
import FAQ from './Pages/FAQ';
import Shop from './Pages/Shop';
// import SaleSubCategoriesProduct from './Pages/SaleSubCategoriesProduct';
// import menSubCategoriesProduct from './Pages/menSubCategoriesProduct';
// import womenSubCategoriesProduct from './Pages/womenSubCategoriesProduct';
import SubCategoriesProduct from './Pages/SubCategoriesProduct';
import SubCategoriesProductDetails from './Pages/SubCategoriesProductDetails';
import SubCategoriesProductDetails1 from './Pages/SubCategoriesProductDetails1';
import SubCategoriesProductDetails2 from './Pages/SubCategoriesProductDetails2';
import SizeProductDetail from './Pages/SizeProductDetail';
import thankyou from './Pages/Thankyou';
import chat from './Pages/chat';
// import WomenOnlySubCategoriesProduct from './Pages/WomenOnlySubCategoriesProduct';
// import MenOnlySubCategoriesProduct from './Pages/MenOnlySubCategoriesProduct';
import SubCategoriesProduct1 from './Pages/SubCategoriesProduct1';
import SubCategoriesProduct2 from './Pages/SubCategoriesProduct2';
import Favorite from './Pages/Favorite';
import whislist from './Pages/whislist';
// import GardenAccessories from './Pages/GardenAccessories';
// import CategoriesUniform from './Pages/CategoriesUniform';
// import UniformClassProduct from './Pages/UniformClassProduct';
// import UniformProductDetails from './Pages/UniformProductDetails';
// import SchoolBookProductDetail from './Pages/SchoolBookProductDetail';
// import BagsProductDetail from './Pages/BagsProductDetail';
// import ArrivalCategoriesProduct from './Pages/ArrivalCategoriesProduct';

import whatapps from './assets/images/what.png';

// import teacherform from './Pages/teacherform';
// import studentform from './Pages/studentform';
import Shipping from './Pages/Shipping';
import Term from './Pages/Term';
import ab from './Pages/ab';
import expertpick from './Pages/expertpick';
import recommendedproduct from './Pages/recommendedproduct';
import newArrival from './Pages/newArrival';
import AMC from './Pages/AMC';
import Land from './Pages/land';
import Error from './Pages/Error';
// import submain from './Pages/submain';

import LandscapeDesign from "./Pages/LandscapeDesign";
import AMCMaintenance from "./Pages/AMCMaintenance";
import KitchenGardening from "./Pages/KitchenGardening";


import SwimmingPoolDesign from "./Pages/SwimmingPoolDesign";


import B1 from './Pages/benefits-of-annual-maintenance-contracts-for-your-garden-plant-in-dubai-with-garden-oasis-landscape-service';
import B2 from './Pages/get-high-quality-artificial-grass-and-transform-your-outdoor-space-at-our-store';
import B3 from './Pages/what-is-landscape-design';
import Sitemap from './Pages/Sitemap';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';



import whatapps1 from './assets/images/png.png';



// import Privacy from './Pages/Privacy';
// import MainUserSignup from './Pages/MainUserSignup';
// import MainUserLogin from './Pages/MainUserLogin';
// import forgetpassaccount from './Pages/forgetpassaccount';


// import help from './Pages/help';
// import userDashboard from './Pages/userDashboard';
// import EditNameAddress from './Pages/EditNameAddress';
// import userDashOrderDetails from './Pages/userDashOrderDetails';


// import SchoolCategories from './Pages/SchoolCategories';
// import SchoolClassesCategories from './Pages/SchoolClassesCategories';
// import SchoolClassesCategoriesProduct from './Pages/SchoolClassesCategoriesProduct';
// import SchoolClassesCategoriesProductDetail from './Pages/SchoolClassesCategoriesProductDetail';


// import $ from 'jquery';


// import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css";
import "./bootstrap.min.css"
import "./all.css"
import "./custom.css"
import "./bootsnav.css"
import "./responsive.css"
import "./style1.css"
import "./css/style.css";
import "./lib/owlcarousel/assets/owl.carousel.min.css";

import "./css1/custom.css";
import "./css1/responsive.css";
import "./css1/bootstrap-select.css";
import "./css1/baguetteBox.min.css";
import "./css1/owl.carousel.min.css";
import "./css1/bootsnav.css";
import "./css1/code_animate.css";
import "./css1/carousel-ticker.css";
import "./css1/superslides.css";
import "./css1/all.css";
import "./css1/style.css";

import "./css1/bootsnav";

import "./asset1/vendor/line-awesome/line-awesome/line-awesome/css/line-awesome.min.css";
import "./asset1/css/bootstrap.min.css";
// import "./asset1/css/plugins/owl-carousel/owl.carousel.css";
import "./asset1/css/plugins/jquery.countdown.css";
import "./asset1/css/plugins/magnific-popup/magnific-popup.css";
import "./asset1/css/style.css";
import "./asset1/css/skins/skin-demo-26.css";
import "./asset1/css/demos/demo-26.css";





function App() {
  
  return (
    <div className="App" >                    
     {/* <a href="https://wa.me/971042766276" target="_blank"><img src={whatapps} alt="" style={{position : "fixed" ,zIndex : "999999", top : "80%" , right : "10px",width:"70px",height : "70px"}}/></a> */}
     <a href="tel:+971509480695" target="_blank"><img src={whatapps1} alt="" style={{position : "fixed" ,zIndex : "999999", top : "80%" , right : "15px",width:"50px",height : "50px"}}/></a>
     <a href="https://wa.me/971509480695?text=Hi *Garden Oasis Landscape *! I need more info about Garden Oasis Landscape  https://gardenoasislandscape.com" target="_blank"><img src={whatapps} alt="" style={{position : "fixed" ,zIndex : "999999", top : "72%" , right : "10px",width:"60px",height : "60px"}}/></a>
     
      <Router>

        <Header />
        
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/client' component={Client} />
          <Route exact path='/portfolio' component={Portfolio} />
          <Route exact path='/term-policy' component={Term} />
          <Route exact path='/Shipping' component={Shipping} />
          <Route exact path='/product/new-arrival' component={newArrival} />
          <Route exact path='/product/recommended-product' component={recommendedproduct} />
          <Route exact path='/product/expert-pick' component={expertpick} />

          <Route exact path='/shop-all' component={ab} />
          <Route exact path='/privacy' component={Privacy} />
          <Route exact path='/favorite' component={Favorite} />
          <Route exact path='/whislist' component={whislist} />
          <Route exact path='/thankyou' component={thankyou} />
          <Route exact path='/consign' component={consign} />
          <Route exact path='/checkout' component={Checkout} />
          <Route exact path='/FAQ' component={FAQ} />
          <Route exact path='/chat' component={chat} />
          <Route exact path='/cart' component={Card} />
          <Route exact path='/all-shop' component={Shop} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/about' component={About} />
          <Route exact path='/track' component={tracking} />
          <Route exact path='/sitemap' component={Sitemap} />




<Route exact
  path="/landscape-design-dubai"
  component={LandscapeDesign}
/>

<Route exact
  path="/amc-packages-dubai-annual-maintenance-contract"
  component={AMCMaintenance}
/>

<Route exact
  path="/kitchen-gardening-dubai"
  component={KitchenGardening}
/>

<Route
  path="/swimming-pool-design-dubai"
  component={SwimmingPoolDesign}
/>







          <Route exact path='/search/product-item' component={SearchData} />
          {/* <Route exact path='/ab' component={SubCategoriesProduct} /> */}
          {/* <Route exact path='/categories/:categoriesName/all-products' component={SubCategoriesProduct} /> */}
          <Route exact path='/categories-main/Annual Maintenance Contract' component={AMC} />
          <Route exact path='/categories-main/Landscaping' component={Land} />
          {/* <Route exact path='/categories-main/Garden Accessories' component={GardenAccessories} /> */}
          <Route exact path='/main-categories/:categoriesName' component={Categories} />
          <Route exact path='/categories/:categoriesName/all-products' component={SubCategoriesProduct2} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/all-products' component={SubCategoriesProduct1} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/:categoriesName2/all-products' component={SubCategoriesProduct} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/:categoriesName2/all-products/:productName/:productId' component={SubCategoriesProductDetails} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/all-products/:productName/:productId' component={SubCategoriesProductDetails2} />
          <Route exact path='/categories/:categoriesName/all-products/:productName/:productId' component={SubCategoriesProductDetails1} />
          {/* <Route exact path='/main-categories/:categoriesName/all-products/:productName/:productId' component={submain} /> */}
          <Route exact path='/main-categories/:categoriesName/:categoriesName1/:categoriesName2/all-products/:productName/:productId' component={SizeProductDetail} />

          <Route exact path='/villa-maintenance-contract-dubai-villa-amc-dubai' component={VillaMaintenanceContractDubaiVillaAMCDubai} />
          <Route exact path='/best-annual-maintenance-contract-packages' component={BestAnnualMaintenanceContractPackages} />
          <Route exact path='/annual-maintenance-contract-in-dubai' component={AnnualMaintenanceContractinDubai} />
          <Route exact path='/annual-maintenance-contracts-dubai' component={AMCindubai} />
          <Route exact path='/amc-packages-dubai-annual-maintenance-contract' component={AMCPackagesDubaiAnnualMaintenanceContract} />
          
          
          <Route exact path='/Indoor Plant Maintenance Service (AMC) in Dubai' component={AMC1} />
          <Route exact path='/Annual Maintenance Contract Dubai AMC Services in UAE' component={AMC2} />
          <Route exact path='/Garden Maintenance AMC Services at Discounted Prices' component={AMC3} />
          <Route exact path='/Dubai Landscape Maintenance - Beautiful Gardens Made Easy' component={AMC4} />
          <Route exact path='/Garden Maintenance AMC Services at Best Offers' component={AMC5} />
          <Route exact path='/Looking For AMC for Your Lawn? Garden Maintenance Services' component={AMC6} />
          <Route exact path='/Garden Maintenance Services Landscaping Services in Dubai' component={AMC7} />
          <Route exact path='/Annual Indoor Plant Maintenance Plant care service Dubai' component={AMC8} />
          
          <Route exact path='/Landscaping Companies in Dubai - Landscaping in Dubai' component={Land1} />
          <Route exact path='/Landscaping Company Dubai Landscaping designer' component={Land2} />
          <Route exact path='/Best Landscaping Company in Dubai' component={Land3} />
          <Route exact path='/Landscaping Dubai | Landscaping Company Dubai' component={Land4} />
          <Route exact path='/Desert Group | Best and Quality Landscaping Company in Dubai' component={Land5} />
          <Route exact path='/Premium Landscaping Company in Dubai' component={Land6} />
          <Route exact path='/Best in Dubai Landscapes | Best UAE Landscaping' component={Land7} />
          <Route exact path='/Landscaping Services Dubai' component={Land8} />
          <Route exact path='/Landscaping Services | Garden Landscaping Company in Dubai' component={Land9} />
          <Route exact path='/Your Top Landscaping Company in Dubai | Planters' component={Land10} />
          <Route exact path='/Best landscape architecture in Dubai - Outdoor Living' component={Land11} />
          <Route exact path='/Landscaping and Gardening services company – Dubai' component={Land12} />
          <Route exact path='/Landscaping Services | Dubai | UAE' component={Land13} />
          <Route exact path='/One of the best landscaping companies in Dubai' component={Land14} />
          <Route exact path='/Best Landscaping Company in Dubai | UAE' component={Land15} />
          <Route exact path='/Gardening Services in Dubai | Top Landscaping & Gardening' component={Land16} />
          
          
          <Route exact path='/benefits-of-annual-maintenance-contracts-for-your-garden-plant-in-dubai-with-garden-oasis-landscape-service' component={B1} />
          <Route exact path='/get-high-quality-artificial-grass-and-transform-your-outdoor-space-at-our-store' component={B2} />
          <Route exact path='/what-is-landscape-design' component={B3} />
      
      
          <Route exact path='/garden-maintenance-services-dubai' component={GardenMaintenanceServicesDubai } />
          <Route exact path='/top-rated-landscaping-and-plant-maintenance-services-dubai' component={TopRatedLandscapingAndPlantMaintenanceServicesDubai } />
          <Route exact path='/premium-garden-maintenance-services-dubai' component={PremiumGardenMaintenanceServicesDubai } />
          <Route exact path='/best-landscaping-and-gardening-services-company-in-dubai' component={BestLandscapingAndGardeningServicesCompanyInDubai } />
          <Route exact path='/garden-landscaping-dubai-expert-garden-care' component={GardenLandscapingDubaiExpertGardenCare } />
          <Route exact path='/book-professional-garden-maintenance-services-in-dubai' component={BookProfessionalGardenMaintenanceServicesInDubai } />
          <Route exact path='/garden-landscaping-dubai-trusted-#1-gardeners-in-dubai' component={GardenLandscapingDubaiTrustedGardenersInDubai } />
          <Route exact path='/dubai-best-landscaping-and-garden-maintenance' component={DubaiBestLandscapingAndGardenMaintenance } />
          <Route exact path='/your-top-landscaping-company-in-dubai' component={YourTopLandscapingCompanyInDubai } />
          <Route exact path='/top-indoor-plants-maintenance-service-dubai' component={TopIndoorPlantsMaintenanceServiceDubai } />
          <Route exact path='/landscape-and-gardening-works-and-maintenance-in-dubai' component={LandscapeAndGardeningWorksAndMaintenanceInDubai } />
          <Route exact path='/affordable-gardening-services-in-dubai' component={AffordableGardeningServicesInDubai } />
          <Route exact path='/landscaping-and-gardening-services-company-dubai' component={LandscapingAndGardeningServicesCompanyDubai } />
          <Route exact path='/urban-landscapes-luxury-landscaping-design-dubai' component={UrbanLandscapesLuxuryLandscapingDesignDubai } />
          <Route exact path='/best-dubai-landscape-dubai-top-landscaping-firm' component={BestDubaiLandscapeDubaiTopLandscapingFirm } />
          <Route exact path='/one-of-the-best-landscaping-companies-in-dubai' component={OneOfTheBestLandscapingCompaniesInDubai } />
          <Route exact path='/premium-landscaping-company-in-dubai' component={PremiumLandscapingCompanyInDubai } />
          <Route exact path='/best-choice-landscape-gardening-llc-dubai' component={BestChoiceLandscapeGardeningLLCDubai } />
          <Route exact path='/landscaping-in-dubai-greenlawn-landscaping-and-gardening' component={LandscapingInDubaiGreenLawnLandscapingAndGardening } />
          <Route exact path='/best-landscaping-and-lawn-service-in-dubai' component={BestLandscapingAndLawnServiceInDubai } />
          <Route exact path='/expert-garden-landscaping-in-dubai-for-your-outdoor-oasis' component={ExpertGardenLandscapingInDubaiOutdoorOasis } />
          <Route exact path='/best-gardening-companies-landscaping-work-in-dubai' component={BestGardeningCompaniesLandscapingWorkInDubai } />
          <Route exact path='/dubai-landscaping-home-office-landscape-indoor-outdoor-#1' component={DubaiLandscapeHomeOfficeLandscapeIndoorOutdoor } />
          <Route exact path='/best-landscaping-companies-in-dubai-villa-garden' component={BestLandscapingCompaniesInDubaiVillaGarden } />
          <Route exact path='/landscaping-services-in-uae-landscaping-company-in-dubai' component={LandscapingServicesInUaeLandscapingCompanyInDubai } />
          <Route exact path='/#1-swimming-pool-and-landscaping-company-in-dubai-uae' component={SwimmingPoolAndLandscapingCompanyInDubaiUae} />
       


      
   <Route exact path='/best-landscaping-company-arabian-ranches' component={LandscapingPage1} />
   <Route exact path='/best-landscaping-company-dubai-marina' component={LandscapingPage2} />
   <Route exact path='/best-landscaping-company-jumeirah-beach-residence' component={LandscapingPage3} />
   <Route exact path='/best-landscaping-company-al-barsha' component={LandscapingPage4} />
   <Route exact path='/best-landscaping-company-downtown-dubai' component={LandscapingPage5} />
   <Route exact path='/best-landscaping-company-business-bay' component={LandscapingPage6} />
   <Route exact path='/best-landscaping-company-al-quoz' component={LandscapingPage7} />
   <Route exact path='/top-garden-design-company-dubai' component={LandscapingPage8} />
   <Route exact path='/best-tree-supplier-dubai' component={LandscapingPage9} />
   <Route exact path='/best-tree-exporter-dubai' component={LandscapingPage10} />
   <Route exact path='/leading-irrigation-system-provider-dubai' component={LandscapingPage11} />
   <Route exact path='/premium-plant-nursery-dubai' component={LandscapingPage12} />
   <Route exact path='/best-outdoor-lighting-solutions-dubai' component={LandscapingPage13} />
   <Route exact path='/best-landscape-maintenance-company-dubai' component={LandscapingPage14} />
   <Route exact path='/top-hardscape-company-dubai' component={LandscapingPage15} />
   <Route exact path='/best-landscaping-service-arabian-ranches-1-2' component={LandscapingPage16} />
   <Route exact path='/best-landscaping-service-dubai-hills-estate' component={LandscapingPage17} />
   <Route exact path='/best-landscaping-service-emirates-hills' component={LandscapingPage18} />
   <Route exact path='/best-landscaping-service-jumeirah' component={LandscapingPage19} />
   <Route exact path='/best-landscaping-service-jumeirah-golf-estate' component={LandscapingPage20} />
   <Route exact path='/best-landscaping-service-dubai-investment-park' component={LandscapingPage21} />
   <Route exact path='/best-landscaping-service-dubai-international-centre' component={LandscapingPage22} />
   <Route exact path='/best-landscaping-service-dubai' component={LandscapingPage23} />
   <Route exact path='/best-landscaping-service-uae' component={LandscapingPage24} />
   <Route exact path='/no1-landscaping-company-dubai' component={LandscapingPage25} />
   <Route exact path='/top-landscaping-company-dubai' component={LandscapingPage26} />







   <Route exact path='/landscape-architects-dubai' component={Landscape1} />
<Route exact path='/landscape-design-company' component={Landscape2} />
<Route exact path='/commercial-landscaping-company-in-dubai' component={Landscape3} />
<Route exact path='/residential-landscaping-company-in-dubai' component={Landscape4} />
<Route exact path='/hardscaping-company-in-dubai' component={Landscape5} />
<Route exact path='/garden-installation-company-in-dubai' component={Landscape6} />
<Route exact path='/horticulture-services-dubai' component={Landscape7} />
<Route exact path='/outdoor-landscaping-service' component={Landscape8} />
<Route exact path='/outdoor-landscaping-service-in-dubai' component={Landscape9} />
<Route exact path='/outdoor-plant-service-in-dubai' component={Landscape10} />
<Route exact path='/outdoor-plant-company-in-dubai' component={Landscape11} />
<Route exact path='/plant-supply-dubai' component={Landscape12} />
<Route exact path='/plant-wholesale-dubai' component={Landscape13} />
<Route exact path='/plant-wholesale-arjan' component={Landscape14} />
<Route exact path='/plant-wholesale-shop-dubai' component={Landscape15} />
<Route exact path='/best-lawn-care-services' component={Landscape16} />
<Route exact path='/grass-installation-dubai' component={Landscape17} />
<Route exact path='/landscaping-service-arjan' component={Landscape18} />
<Route exact path='/landscaping-service-uae' component={Landscape19} />
<Route exact path='/landscaping-company-arjan' component={Landscape20} />
<Route exact path='/garden-shop-arjan-dubai' component={Landscape21} />
<Route exact path='/plant-shop-arjan-dubai' component={Landscape22} />
<Route exact path='/indoor-plant-shop-arjan-dubai' component={Landscape23} />




<Route exact path="/garden-shop-meydan-dubai" component={Page1} />
<Route exact path="/garden-shop-design-district" component={Page2} />
<Route exact path="/garden-shop-barari-dubai" component={Page3} />
<Route exact path="/garden-shop-al-furjan" component={Page4} />
<Route exact path="/garden-shop-tilal-al-ghaf" component={Page5} />
<Route exact path="/garden-shop-arabian-ranches-2" component={Page6} />
<Route exact path="/garden-shop-tilal-al-furjan" component={Page7} />
<Route exact path="/garden-shop-al-wasl-gate" component={Page8} />
<Route exact path="/garden-shop-damac-hills" component={Page9} />
<Route exact path="/garden-shop-emaar-south" component={Page10} />
<Route exact path="/garden-shop-sobha-hartland" component={Page11} />
<Route exact path="/garden-shop-meraas" component={Page12} />
<Route exact path="/garden-shop-samana" component={Page13} />
<Route exact path="/garden-shop-california-village" component={Page14} />
<Route exact path="/garden-shop-falcon-city-of-wonders" component={Page15} />


<Route exact path="/landscaping-services-meydan-dubai" component={Page16} />
<Route exact path="/landscaping-services-design-district" component={Page17} />
<Route exact path="/landscaping-services-barari-dubai" component={Page18} />
<Route exact path="/landscaping-services-al-furjan" component={Page19} />
<Route exact path="/landscaping-services-tilal-al-ghaf" component={Page20} />
<Route exact path="/landscaping-services-arabian-ranches-2" component={Page21} />
<Route exact path="/landscaping-services-tilal-al-furjan" component={Page22} />
<Route exact path="/landscaping-services-al-wasl-gate" component={Page23} />
<Route exact path="/landscaping-services-damac-hills" component={Page24} />
<Route exact path="/landscaping-services-emaar-south" component={Page25} />
<Route exact path="/landscaping-services-sobha-hartland" component={Page26} />
<Route exact path="/landscaping-services-meraas" component={Page27} />
<Route exact path="/landscaping-services-samana" component={Page28} />
<Route exact path="/landscaping-services-california-village" component={Page29} />
<Route exact path="/landscaping-services-falcon-city-of-wonders" component={Page30} />



<Route exact path="/indoor-plant-shop-meydan-dubai" component={Page31} />
<Route exact path="/indoor-plant-shop-design-district" component={Page32} />
<Route exact path="/indoor-plant-shop-barari-dubai" component={Page33} />
<Route exact path="/indoor-plant-shop-al-furjan" component={Page34} />
<Route exact path="/indoor-plant-shop-tilal-al-ghaf" component={Page35} />
<Route exact path="/indoor-plant-shop-arabian-ranches-2" component={Page36} />
<Route exact path="/indoor-plant-shop-tilal-al-furjan" component={Page37} />
<Route exact path="/indoor-plant-shop-al-wasl-gate" component={Page38} />
<Route exact path="/indoor-plant-shop-damac-hills" component={Page39} />
<Route exact path="/indoor-plant-shop-emaar-south" component={Page40} />
<Route exact path="/indoor-plant-shop-sobha-hartland" component={Page41} />
<Route exact path="/indoor-plant-shop-meraas" component={Page42} />
<Route exact path="/indoor-plant-shop-samana" component={Page43} />
<Route exact path="/indoor-plant-shop-california-village" component={Page44} />
<Route exact path="/indoor-plant-shop-falcon-city-of-wonders" component={Page45} />
<Route exact path="/indoor-plant-shop-dubai" component={Page46} />

<Route exact path="/outdoor-plant-shop-dubai" component={Page47} />
<Route exact path="/outdoor-plant-shop-arjan" component={Page48} />
<Route exact path="/outdoor-plant-shop-meydan-dubai" component={Page49} />
<Route exact path="/outdoor-plant-shop-design-district" component={Page50} />
<Route exact path="/outdoor-plant-shop-barari-dubai" component={Page51} />
<Route exact path="/outdoor-plant-shop-al-furjan" component={Page52} />
<Route exact path="/outdoor-plant-shop-tilal-al-ghaf" component={Page53} />
<Route exact path="/outdoor-plant-shop-arabian-ranches-2" component={Page54} />
<Route exact path="/outdoor-plant-shop-tilal-al-furjan" component={Page55} />
<Route exact path="/outdoor-plant-shop-al-wasl-gate" component={Page56} />
<Route exact path="/outdoor-plant-shop-damac-hills" component={Page57} />
<Route exact path="/outdoor-plant-shop-emaar-south" component={Page58} />
<Route exact path="/outdoor-plant-shop-sobha-hartland" component={Page59} />
<Route exact path="/outdoor-plant-shop-meraas" component={Page60} />
<Route exact path="/outdoor-plant-shop-samana" component={Page61} />
<Route exact path="/outdoor-plant-shop-california-village" component={Page62} />
<Route exact path="/outdoor-plant-shop-falcon-city-of-wonders" component={Page63} />

<Route exact path="/best-soil-for-gardening-in-dubai" component={Page64} />
<Route exact path="/premium-soil-suppliers-in-dubai" component={Page65} />
<Route exact path="/buy-organic-soil-for-plants-in-dubai" component={Page66} />
<Route exact path="/top-quality-stones-for-landscaping-in-dubai" component={Page67} />
<Route exact path="/soil-and-stone-delivery-service-in-dubai" component={Page68} />
<Route exact path="/landscaping-soil-solutions-in-dubai" component={Page69} />
<Route exact path="/affordable-soil-for-planting-in-dubai" component={Page70} />
<Route exact path="/best-garden-stones-for-dubai-gardens" component={Page71} />
<Route exact path="/dubais-leading-soil-and-stone-providers" component={Page72} />
<Route exact path="/garden-soil-for-dubais-climate-and-terrain" component={Page73} />

<Route exact path="/organic-fertilizers-for-dubai-gardens" component={Page74} />
<Route exact path="/best-pesticides-for-indoor-plants-in-dubai" component={Page75} />
<Route exact path="/premium-fertilizers-for-dubai-plants" component={Page76} />
<Route exact path="/safe-and-effective-pesticides-in-dubai" component={Page77} />
<Route exact path="/buy-fertilizers-online-in-dubai" component={Page78} />
<Route exact path="/eco-friendly-fertilizers-for-gardens-in-dubai" component={Page79} />
<Route exact path="/pest-control-products-for-dubai-homes" component={Page80} />
<Route exact path="/fertilizer-solutions-for-dubais-climate" component={Page81} />
<Route exact path="/top-rated-fertilizer-suppliers-in-dubai" component={Page82} />
<Route exact path="/dubais-leading-pesticide-distributors" component={Page83} />

<Route exact path="/stylish-pots-and-planters-in-dubai" component={Page84} />
<Route exact path="/buy-outdoor-planters-in-dubai" component={Page85} />
<Route exact path="/modern-pots-for-indoor-plants-in-dubai" component={Page86} />
<Route exact path="/best-planters-for-dubais-weather" component={Page87} />
<Route exact path="/high-quality-pots-for-dubai-gardens" component={Page88} />
<Route exact path="/affordable-planters-for-home-gardens-in-dubai" component={Page89} />
<Route exact path="/custom-planters-for-dubai-homes" component={Page90} />
<Route exact path="/elegant-flower-pots-in-dubai" component={Page91} />
<Route exact path="/large-pots-for-dubai-landscaping" component={Page92} />
<Route exact path="/potting-solutions-for-dubai-gardens" component={Page93} />

<Route exact path="/artificial-plants-for-dubai-homes" component={Page94} />
<Route exact path="/best-artificial-indoor-plants-in-dubai" component={Page95} />
<Route exact path="/buy-realistic-artificial-plants-in-dubai" component={Page96} />
<Route exact path="/low-maintenance-artificial-plants-for-dubai" component={Page97} />
<Route exact path="/top-artificial-plants-suppliers-in-dubai" component={Page98} />
<Route exact path="/faux-plants-for-office-spaces-in-dubai" component={Page99} />
<Route exact path="/beautiful-artificial-plants-for-dubai-gardens" component={Page100} />
<Route exact path="/best-artificial-flowers-for-dubai-interiors" component={Page101} />
<Route exact path="/indoor-artificial-plants-for-dubai-apartments" component={Page102} />
<Route exact path="/dubais-leading-artificial-plant-retailers" component={Page103} />



<Route exact path="/outdoor-planters-for-dubai-harbour-homes" component={Page104} />
<Route exact path="/buy-artificial-plants-in-dubai-harbour" component={Page105} />
<Route exact path="/eco-friendly-fertilizers-dubai-harbour" component={Page106} />
<Route exact path="/garden-maintenance-services-in-dubai-harbour" component={Page107} />
<Route exact path="/stylish-indoor-plants-dubai-harbour" component={Page108} />
<Route exact path="/top-gardening-shop-in-dubai-harbour" component={Page109} />
<Route exact path="/indoor-plant-shop-in-mbr-city-dubai" component={Page110} />
<Route exact path="/buy-fertilizers-near-mohammed-rashid-al-maktoum-city" component={Page111} />
<Route exact path="/landscaping-services-in-mohammed-rashid-al-maktoum-city" component={Page112} />
<Route exact path="/stylish-pots-and-planters-in-mbr-city-dubai" component={Page113} />
<Route exact path="/organic-garden-supplies-in-mohammed-rashid-al-maktoum-city" component={Page114} />
<Route exact path="/buy-outdoor-plants-in-mohammed-rashid-al-maktoum-city" component={Page115} />
<Route exact path="/artificial-plants-for-homes-in-mbr-city" component={Page116} />
<Route exact path="/premium-gardening-tools-in-mohammed-rashid-al-maktoum-city" component={Page117} />
<Route exact path="/garden-stones-and-pebbles-near-mbr-city" component={Page118} />
<Route exact path="/balcony-plant-setup-in-mohammed-rashid-al-maktoum-city" component={Page119} />
<Route exact path="/garden-maintenance-services-mbr-city" component={Page120} />
<Route exact path="/buy-flower-pots-in-mohammed-rashid-al-maktoum-city" component={Page121} />
<Route exact path="/affordable-planters-for-mbr-city-residents" component={Page122} />
<Route exact path="/home-garden-makeover-in-mbr-city" component={Page123} />
<Route exact path="/indoor-gardening-solutions-mbr-city-apartments" component={Page124} />


<Route exact path="/organic-fertilizers-near-dubai-harbour" component={Page125} />
<Route exact path="/garden-landscaping-services-in-dubai-harbour" component={Page126} />
<Route exact path="/buy-plant-pots-in-dubai-harbour" component={Page127} />
<Route exact path="/indoor-plants-delivery-dubai-harbour" component={Page128} />




<Route exact path="/indoor-plants-act-one-act-two-dubai" component={Page129} />
<Route exact path="/indoor-plants-address-opera-dubai" component={Page130} />
<Route exact path="/indoor-plants-bel-air-dubai" component={Page131} />
<Route exact path="/indoor-plants-bliss-1-2-dubai" component={Page132} />
<Route exact path="/indoor-plants-burj-crown-dubai" component={Page133} />
<Route exact path="/indoor-plants-emaar-oasis-dubai" component={Page134} />
<Route exact path="/indoor-plants-golf-acres-dubai-south" component={Page135} />
<Route exact path="/indoor-plants-golf-dale-dubai-south" component={Page136} />
<Route exact path="/indoor-plants-golf-edge-dubai-south" component={Page137} />
<Route exact path="/indoor-plants-golf-lane-dubai-south" component={Page138} />
<Route exact path="/indoor-plants-golf-links-dubai-south" component={Page139} />
<Route exact path="/indoor-plants-golf-links-1-2-dubai-south" component={Page140} />
<Route exact path="/indoor-plants-green-ridge-dubai-south" component={Page141} />
<Route exact path="/indoor-plants-greens-point-dubai-south" component={Page142} />
<Route exact path="/indoor-plants-green-ville-dubai-south" component={Page143} />
<Route exact path="/indoor-plants-green-way-1-2-dubai-south" component={Page144} />
<Route exact path="/indoor-plants-luxur-tower-imtiaz" component={Page145} />
<Route exact path="/indoor-plants-majara-dm-dubai" component={Page146} />
<Route exact path="/indoor-plants-maple-1-2-3-dubai" component={Page147} />
<Route exact path="/indoor-plants-sirda-1-2-3-dubai" component={Page148} />
<Route exact path="/indoor-plants-park-residences-dubai" component={Page149} />
<Route exact path="/indoor-plants-pearl-house-imtiaz" component={Page150} />
<Route exact path="/indoor-plants-r3-ruba-dubai" component={Page151} />
<Route exact path="/indoor-plants-raya-1-dubai" component={Page152} />
<Route exact path="/indoor-plants-reportage-village-dubai" component={Page153} />
<Route exact path="/indoor-plants-silver-spring-trump-estate-2" component={Page154} />
<Route exact path="/indoor-plants-silver-springs-dubai" component={Page155} />
<Route exact path="/indoor-plants-sobha-creek-vistas-grande" component={Page156} />
<Route exact path="/indoor-plants-south-bay-dubai-south" component={Page157} />
<Route exact path="/indoor-plants-the-valley-dubai" component={Page158} />
<Route exact path="/indoor-plants-veneto-1-dubai" component={Page159} />
<Route exact path="/indoor-plants-westwood-grande-ii-imtiaz" component={Page160} />




<Route exact path="/landscaping-service-act-one-act-two-dubai" component={Page161} />
<Route exact path="/landscaping-service-address-opera-dubai" component={Page162} />
<Route exact path="/landscaping-service-bel-air-dubai" component={Page163} />
<Route exact path="/landscaping-service-bliss-1-2-dubai" component={Page164} />
<Route exact path="/landscaping-service-burj-crown-dubai" component={Page165} />
<Route exact path="/landscaping-service-emaar-oasis-dubai" component={Page166} />
<Route exact path="/landscaping-service-golf-acres-dubai-south" component={Page167} />
<Route exact path="/landscaping-service-golf-dale-dubai-south" component={Page168} />
<Route exact path="/landscaping-service-golf-edge-dubai-south" component={Page169} />
<Route exact path="/landscaping-service-golf-lane-dubai-south" component={Page170} />
<Route exact path="/landscaping-service-golf-links-dubai-south" component={Page171} />
<Route exact path="/landscaping-service-golf-links-1-2-dubai-south" component={Page172} />
<Route exact path="/landscaping-service-green-ridge-dubai-south" component={Page173} />
<Route exact path="/landscaping-service-greens-point-dubai-south" component={Page174} />
<Route exact path="/landscaping-service-green-ville-dubai-south" component={Page175} />
<Route exact path="/landscaping-service-green-way-1-2-dubai-south" component={Page176} />
<Route exact path="/landscaping-service-luxur-tower-imtiaz" component={Page177} />
<Route exact path="/landscaping-service-majara-dm-dubai" component={Page178} />
<Route exact path="/landscaping-service-maple-1-2-3-dubai" component={Page179} />
<Route exact path="/landscaping-service-sirda-1-2-3-dubai" component={Page180} />
<Route exact path="/landscaping-service-park-residences-dubai" component={Page181} />
<Route exact path="/landscaping-service-pearl-house-imtiaz" component={Page182} />
<Route exact path="/landscaping-service-r3-ruba-dubai" component={Page183} />
<Route exact path="/landscaping-service-raya-1-dubai" component={Page184} />
<Route exact path="/landscaping-service-reportage-village-dubai" component={Page185} />
<Route exact path="/landscaping-service-silver-spring-trump-estate-2" component={Page186} />
<Route exact path="/landscaping-service-silver-springs-dubai" component={Page187} />
<Route exact path="/landscaping-service-sobha-creek-vistas-grande" component={Page188} />
<Route exact path="/landscaping-service-south-bay-dubai-south" component={Page189} />
<Route exact path="/landscaping-service-the-valley-dubai" component={Page190} />
<Route exact path="/landscaping-service-veneto-1-dubai" component={Page191} />
<Route exact path="/landscaping-service-westwood-grande-ii-imtiaz" component={Page192} />













<Route exact path="/swimming-pool-maintenance/palm-jumeirah" component={Page193} />
<Route exact path="/swimming-pool-maintenance/jumeirah-islands" component={Page194} />
<Route exact path="/swimming-pool-maintenance/jumeirah-park" component={Page195} />
<Route exact path="/swimming-pool-maintenance/dubai-hills-estate" component={Page196} />
<Route exact path="/swimming-pool-maintenance/arabian-ranches-2" component={Page197} />
<Route exact path="/swimming-pool-maintenance/damac-hills" component={Page198} />
<Route exact path="/swimming-pool-maintenance/damac-lagoons" component={Page199} />
<Route exact path="/swimming-pool-maintenance/sustainable-city" component={Page200} />
<Route exact path="/swimming-pool-maintenance/al-barari" component={Page201} />
<Route exact path="/swimming-pool-maintenance/jumeirah-golf-estates" component={Page202} />
<Route exact path="/swimming-pool-maintenance/tilal-al-ghaf" component={Page203} />


<Route exact path="/indoor-plants/palm-jumeirah" component={Page204} />
<Route exact path="/indoor-plants/jumeirah-islands" component={Page205} />
<Route exact path="/indoor-plants/jumeirah-park" component={Page206} />
<Route exact path="/indoor-plants/dubai-hills-estate" component={Page207} />
<Route exact path="/indoor-plants/arabian-ranches-2" component={Page208} />
<Route exact path="/indoor-plants/damac-hills" component={Page209} />
<Route exact path="/indoor-plants/damac-lagoons" component={Page210} />
<Route exact path="/indoor-plants/sustainable-city" component={Page211} />
<Route exact path="/indoor-plants/al-barari" component={Page212} />
<Route exact path="/indoor-plants/jumeirah-golf-estates" component={Page213} />
<Route exact path="/indoor-plants/tilal-al-ghaf" component={Page214} />
<Route exact path="/landscaping/jumeirah-islands" component={Page215} />
<Route exact path="/landscaping/jumeirah-park" component={Page216} />
<Route exact path="/landscaping/damac-hills" component={Page217} />
<Route exact path="/landscaping/damac-lagoons" component={Page218} />
<Route exact path="/landscaping/sustainable-city" component={Page219} />
<Route exact path="/landscaping/al-barari" component={Page220} />
<Route exact path="/landscaping/tilal-al-ghaf" component={Page221} />


<Route exact path="/villa-maintenance/palm-jumeirah" component={Page222} />
<Route exact path="/villa-maintenance/jumeirah-islands" component={Page223} />
<Route exact path="/villa-maintenance/jumeirah-park" component={Page224} />
<Route exact path="/villa-maintenance/arabian-ranches-2" component={Page225} />
<Route exact path="/villa-maintenance/damac-hills" component={Page226} />
<Route exact path="/villa-maintenance/damac-lagoons" component={Page227} />
<Route exact path="/villa-maintenance/sustainable-city" component={Page228} />
<Route exact path="/villa-maintenance/al-barari" component={Page229} />
<Route exact path="/villa-maintenance/jumeirah-golf-estates" component={Page230} />
<Route exact path="/villa-maintenance/tilal-al-ghaf" component={Page231} />


<Route exact path="/pest-control/palm-jumeirah" component={Page232} />
<Route exact path="/pest-control/jumeirah-islands" component={Page233} />
<Route exact path="/pest-control/jumeirah-park" component={Page234} />
<Route exact path="/pest-control/dubai-hills-estate" component={Page235} />
<Route exact path="/pest-control/arabian-ranches-2" component={Page236} />
<Route exact path="/pest-control/damac-hills" component={Page237} />
<Route exact path="/pest-control/damac-lagoons" component={Page238} />
<Route exact path="/pest-control/sustainable-city" component={Page239} />
<Route exact path="/pest-control/al-barari" component={Page240} />
<Route exact path="/pest-control/jumeirah-golf-estates" component={Page241} />
<Route exact path="/pest-control/tilal-al-ghaf" component={Page242} />


<Route exact path="/garden-shop/jumeirah-islands" component={Page243} />
<Route exact path="/garden-shop/jumeirah-park" component={Page244} />
<Route exact path="/garden-shop/dubai-hills-estate" component={Page245} />
<Route exact path="/garden-shop/arabian-ranches-2" component={Page246} />
<Route exact path="/garden-shop/damac-hills" component={Page247} />
<Route exact path="/garden-shop/damac-lagoons" component={Page248} />
<Route exact path="/garden-shop/sustainable-city" component={Page249} />
<Route exact path="/garden-shop/al-barari" component={Page250} />
<Route exact path="/garden-shop/tilal-al-ghaf" component={Page251} />

<Route exact path="/plant-wholesale/jumeirah-islands" component={Page252} />
<Route exact path="/plant-wholesale/jumeirah-park" component={Page253} />
<Route exact path="/plant-wholesale/dubai-hills-estate" component={Page254} />
<Route exact path="/plant-wholesale/arabian-ranches-2" component={Page255} />
<Route exact path="/plant-wholesale/damac-hills" component={Page256} />
<Route exact path="/plant-wholesale/damac-lagoons" component={Page257} />
<Route exact path="/plant-wholesale/sustainable-city" component={Page258} />
<Route exact path="/plant-wholesale/al-barari" component={Page259} />
<Route exact path="/plant-wholesale/jumeirah-golf-estates" component={Page260} />
<Route exact path="/plant-wholesale/tilal-al-ghaf" component={Page261} />

<Route exact path="/commercial-landscaping/palm-jumeirah" component={Page262} />
<Route exact path="/commercial-landscaping/jumeirah-islands" component={Page263} />
<Route exact path="/commercial-landscaping/jumeirah-park" component={Page264} />
<Route exact path="/commercial-landscaping/dubai-hills-estate" component={Page265} />
<Route exact path="/commercial-landscaping/arabian-ranches-2" component={Page266} />
<Route exact path="/commercial-landscaping/damac-hills" component={Page267} />
<Route exact path="/commercial-landscaping/damac-lagoons" component={Page268} />
<Route exact path="/commercial-landscaping/sustainable-city" component={Page269} />
<Route exact path="/commercial-landscaping/al-barari" component={Page270} />
<Route exact path="/commercial-landscaping/jumeirah-golf-estates" component={Page271} />
<Route exact path="/commercial-landscaping/tilal-al-ghaf" component={Page272} />


<Route exact path="/annual-maintenance/jumeirah-islands" component={Page273} />
<Route exact path="/annual-maintenance/jumeirah-park" component={Page274} />
<Route exact path="/annual-maintenance/dubai-hills-estate" component={Page275} />
<Route exact path="/annual-maintenance/arabian-ranches-2" component={Page276} />
<Route exact path="/annual-maintenance/damac-hills" component={Page277} />
<Route exact path="/annual-maintenance/damac-lagoons" component={Page278} />
<Route exact path="/annual-maintenance/sustainable-city" component={Page279} />
<Route exact path="/annual-maintenance/al-barari" component={Page280} />
<Route exact path="/annual-maintenance/jumeirah-golf-estates" component={Page281} />
<Route exact path="/annual-maintenance/tilal-al-ghaf" component={Page282} />












          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/track' component={tracking} /> */}
          
          

          {/* 
          Garden Maintenance Services Dubai
Top-Rated Landscaping and Plant Maintenance Services Dubai
Premium Garden Maintenance Services Dubai
Best Landscaping & Gardening Services Company in Dubai
Garden Landscaping Dubai - Expert Garden Care
Book Professional Garden Maintenance Services In Dubai
Garden Landscaping Dubai | Trusted #1 Gardeners in Dubai
Dubai Best Landscaping And Garden Maintenance
Your Top Landscaping Company in Dubai 
Top Indoor Plants Maintenance Service Dubai 
Landscape & Gardening works & Maintenance in Dubai
Affordable Gardening Services in Dubai
Landscaping and Gardening services company – Dubai
Urban Landscapes | Luxury Landscaping Design Dubai
Best Dubai Landscape | Dubai's top landscaping firm
One of the best landscaping companies in Dubai
Premium Landscaping Company in Dubai
Best Choice Landscape Gardening LLC Dubai
Landscaping in Dubai | Greenlawn Landscaping & gardening
Best Landscaping And Lawn Service In Dubai
Expert Garden Landscaping in Dubai for Your Outdoor Oasis
Best Gardening Companies Landscaping Work in Dubai
Dubai Landscaping | Home office Landscape Indoor Outdoor #1
Best Landscaping Companies in Dubai-Villa Garden
Landscaping Services in UAE: Landscaping Company in Dubai
#1 Swimming Pool and Landscaping Company in Dubai, UAE */}


























AMC Service in Downtown Dubai

AMC Service in Dubai Marina

AMC Service in Palm Jumeirah

AMC Service in Jumeirah

AMC Service in Business Bay

AMC Service in Al Quoz

AMC Service in Deira

AMC Service in Al Barsha

AMC Service in Dubai Internet City

AMC Service in Dubai Media City

AMC Service in Dubai Silicon Oasis

AMC Service in Dubai Creek

AMC Service in Al Nahda

AMC Service in Sheikh Zayed Road

AMC Service in Dubai Sports City

AMC Service in Mirdif

AMC Service in Jumeirah Beach Residence

AMC Service in Bur Dubai

AMC Service in Al Rigga

AMC Service in Dubai Festival City

AMC Service in The Greens

AMC Service in Dubai Design District

AMC Service in Global Village

AMC Service in Dubai Healthcare City

AMC Service in Dubai Gold Souk

AMC Service in Dubai Frame

AMC Service in Dubai Hills Estate

AMC Service in Al Wasl

AMC Service in Emirates Hills

AMC Service in Reem Community

AMC Service in Mira Oasis

AMC Service in Dubailand

AMC Service in Springs 1

AMC Service in Golden Mile Galleria

AMC Service in Oceana Residences

AMC Service in Tiara Residences

AMC Service in Maria Residences

Swimming Pool Maintenance Service in Downtown Dubai

Swimming Pool Maintenance Service in Dubai Marina

Swimming Pool Maintenance Service in Palm Jumeirah

Swimming Pool Maintenance Service in Jumeirah

Swimming Pool Maintenance Service in Business Bay

Swimming Pool Maintenance Service in Al Quoz

Swimming Pool Maintenance Service in Deira

Swimming Pool Maintenance Service in Al Barsha

Swimming Pool Maintenance Service in Dubai Internet City

Swimming Pool Maintenance Service in Dubai Media City

Swimming Pool Maintenance Service in Dubai Silicon Oasis

Swimming Pool Maintenance Service in Dubai Creek

Swimming Pool Maintenance Service in Al Nahda

Swimming Pool Maintenance Service in Sheikh Zayed Road

Swimming Pool Maintenance Service in Dubai Sports City

Swimming Pool Maintenance Service in Mirdif

Swimming Pool Maintenance Service in Jumeirah Beach Residence

Swimming Pool Maintenance Service in Bur Dubai

Swimming Pool Maintenance Service in Al Rigga

Swimming Pool Maintenance Service in Dubai Festival City

Swimming Pool Maintenance Service in The Greens

Swimming Pool Maintenance Service in Dubai Design District

Swimming Pool Maintenance Service in Global Village

Swimming Pool Maintenance Service in Dubai Healthcare City

Swimming Pool Maintenance Service in Dubai Gold Souk

Swimming Pool Maintenance Service in Dubai Frame

Swimming Pool Maintenance Service in Dubai Hills Estate

Swimming Pool Maintenance Service in Al Wasl

Swimming Pool Maintenance Service in Emirates Hills

Swimming Pool Maintenance Service in Reem Community

Swimming Pool Maintenance Service in Mira Oasis

Swimming Pool Maintenance Service in Dubailand

Swimming Pool Maintenance Service in Springs 1

Swimming Pool Maintenance Service in Golden Mile Galleria

Swimming Pool Maintenance Service in Oceana Residences

Swimming Pool Maintenance Service in Tiara Residences

Swimming Pool Maintenance Service in Maria Residences

Landscaping Service in Downtown Dubai

Landscaping Service in Dubai Marina

Landscaping Service in Palm Jumeirah

Landscaping Service in Jumeirah

Landscaping Service in Business Bay

Landscaping Service in Al Quoz

Landscaping Service in Deira

Landscaping Service in Al Barsha

Landscaping Service in Dubai Internet City

Landscaping Service in Dubai Media City

Landscaping Service in Dubai Silicon Oasis

Landscaping Service in Dubai Creek

Landscaping Service in Al Nahda

Landscaping Service in Sheikh Zayed Road

Landscaping Service in Dubai Sports City

Landscaping Service in Mirdif

Landscaping Service in Jumeirah Beach Residence

Landscaping Service in Bur Dubai

Landscaping Service in Al Rigga

Landscaping Service in Dubai Festival City

Landscaping Service in The Greens

Landscaping Service in Dubai Design District

Landscaping Service in Global Village

Landscaping Service in Dubai Healthcare City

Landscaping Service in Dubai Gold Souk

Landscaping Service in Dubai Frame

Landscaping Service in Dubai Hills Estate

Landscaping Service in Al Wasl

Landscaping Service in Emirates Hills

Landscaping Service in Reem Community

Landscaping Service in Mira Oasis

Landscaping Service in Dubailand

Landscaping Service in Springs 1

Landscaping Service in Golden Mile Galleria

Landscaping Service in Oceana Residences

Landscaping Service in Tiara Residences

Landscaping Service in Maria Residences

Plant Shop in Downtown Dubai

Plant Shop in Dubai Marina

Plant Shop in Palm Jumeirah

Plant Shop in Jumeirah

Plant Shop in Business Bay

Plant Shop in Al Quoz

Plant Shop in Deira

Plant Shop in Al Barsha

Plant Shop in Dubai Internet City

Plant Shop in Dubai Media City

Plant Shop in Dubai Silicon Oasis

Plant Shop in Dubai Creek

Plant Shop in Al Nahda

Plant Shop in Sheikh Zayed Road

Plant Shop in Dubai Sports City

Plant Shop in Mirdif

Plant Shop in Jumeirah Beach Residence

Plant Shop in Bur Dubai

Plant Shop in Al Rigga

Plant Shop in Dubai Festival City

Plant Shop in The Greens

Plant Shop in Dubai Design District

Plant Shop in Global Village

Plant Shop in Dubai Healthcare City

Plant Shop in Dubai Gold Souk

Plant Shop in Dubai Frame

Plant Shop in Dubai Hills Estate

Plant Shop in Al Wasl

Plant Shop in Emirates Hills

Plant Shop in Reem Community

Plant Shop in Mira Oasis

Plant Shop in Dubailand

Plant Shop in Springs 1

Plant Shop in Golden Mile Galleria

Plant Shop in Oceana Residences

Plant Shop in Tiara Residences

Plant Shop in Maria Residences

Garden Shop in Downtown Dubai

Garden Shop in Dubai Marina

Garden Shop in Palm Jumeirah

Garden Shop in Jumeirah

Garden Shop in Business Bay

Garden Shop in Al Quoz

Garden Shop in Deira

Garden Shop in Al Barsha

Garden Shop in Dubai Internet City

Garden Shop in Dubai Media City

Garden Shop in Dubai Silicon Oasis

Garden Shop in Dubai Creek

Garden Shop in Al Nahda

Garden Shop in Sheikh Zayed Road

Garden Shop in Dubai Sports City

Garden Shop in Mirdif

Garden Shop in Jumeirah Beach Residence

Garden Shop in Bur Dubai

Garden Shop in Al Rigga

Garden Shop in Dubai Festival City

Garden Shop in The Greens

Garden Shop in Dubai Design District

Garden Shop in Global Village

Garden Shop in Dubai Healthcare City

Garden Shop in Dubai Gold Souk

Garden Shop in Dubai Frame

Garden Shop in Dubai Hills Estate

Garden Shop in Al Wasl

Garden Shop in Emirates Hills

Garden Shop in Reem Community

Garden Shop in Mira Oasis

Garden Shop in Dubailand

Garden Shop in Springs 1

Garden Shop in Golden Mile Galleria

Garden Shop in Oceana Residences

Garden Shop in Tiara Residences

Garden Shop in Maria Residences










          <Route path='*' component={Error} />

        </Switch>

        <Footer />

      </Router>
    </div>
  );
}

export default App;

